module.exports = __webpack_public_path__ + "img/SuperOK8_white.252eb112.png";